<template >
    <div class="main">
        <div class="navBarArea">
            <nav-bar :scrolled="false" :nowSelectedPage=0></nav-bar>
        </div>
        <div class="carouselArea" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
            <el-carousel trigger="click" 
            :autoplay="false" 
            :interval=6000
            :height="isMobile ? 'calc(100vh - 4rem)' : 'calc(100vh - 6rem)'" 
            class="carousel" 
            ref="swiper" 
            :pause-on-hover="false"
            :motion-blur="true"
            
            @change="changePic">
                <el-carousel-item v-for="item, index in picList" :key="`homePic-${index}`" class="item">
                    <img :src="item" alt="" style="object-fit: cover; width: 100%; height: 100%;" :style="isMobile ? {filter: 'blur(3px)', transform: 'scale(1.05)'} : {}">
                </el-carousel-item>
            </el-carousel>
            <div class="textArea">
                <img :src="sloganList[selectedBriefIndex]" alt="" class="slogan">
                <div class="brief" :style="{color: briefColorList[selectedBriefIndex]}">
                    {{briefList[selectedBriefIndex]}}
                </div>
            </div>
            
        </div>
        <page-footer style="z-index: 8; position: fixed; bottom: 0; left: 0;"></page-footer>
    </div>
    
    
</template>

<script>
import {ElCarousel, ElCarouselItem} from 'element-plus';
import PageFooter from "./PageFooter.vue";

export default {
    props: {
        attr: {}
    },
    components: {
        ElCarousel,
        ElCarouselItem,
        PageFooter,
    },

    mounted () {
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.checkMobile);
    },

    data() {
        return {
            isMobile: false,
            sloganList: [
                require("../assets/home/slogan/0.webp"),
                require("../assets/home/slogan/1.webp"),
                require("../assets/home/slogan/2.webp"),
            ],
            desktopPicList: [
              require("../assets/home/background/0.webp"),
              require("../assets/home/background/1.webp"),
              require("../assets/home/background/2.webp"),
            ],
            mobilePicList: [
              require("../assets/home/background/0_mobile.webp"),
              require("../assets/home/background/1_mobile.webp"),
              require("../assets/home/background/2_mobile.webp"),
            ],
            screenSize: [0, 0],
            swiperHeight: "100vh",
            selectedBriefIndex: 0,
            briefList: [
                "Trusted by veterinary professionals worldwide, Allvita delivers scientifically formulated products that support your pet's well-being with the quality and care.",
                "Allvita offers premium pet care products that combine cutting-edge veterinary science with global standards, ensuring your pet’s health is in the best hands, at an affordable price.",
                "Our carefully crafted pet products are designed to meet the highest veterinary standards, providing your pets with the best care possible for a healthier, happier life."
            ],
            briefColorList: [
                "#2C2B2B",
                "#2C2B2B",
                "#2C2B2B",
            ],
            touchStartX: 0,
            touchEndX: 0,
        }
    },
    computed: {
        picList() {
            return this.isMobile ? this.mobilePicList : this.desktopPicList;
        }
    },

    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth < 768;
        },
        changePic(next) {
            // console.log([prev, next])
            
            window.$(".textArea").css("opacity", "0")
            this.selectedBriefIndex = next
            
            setTimeout(
                function() {
                    this.$(".textArea").css("opacity", "1")
                },
                200
            )
        },
        handleTouchStart(e) {
            this.touchStartX = e.changedTouches[0].screenX
        },
        handleTouchEnd(e) {
            this.touchEndX = e.changedTouches[0].screenX
            this.handleSwipe()
        },
        handleSwipe() {
            if (this.touchEndX < this.touchStartX - 50) {
                this.$refs.swiper.next()
            }
            if (this.touchEndX > this.touchStartX + 50) {
                this.$refs.swiper.prev()
            }
        },
    }

}
</script >

<style scoped lang="scss">
.main {
    padding-top: $navBarHeight;
    width: 100%;
    height: 100%;
    position: relative;
}

:deep(.el-carousel__button) {
    height: 0.8vh;
    width: 22.5vw;
    border-radius: 0.4vh;
    opacity: 1;
    background-color: #EEEEEE;
}

:deep(.el-carousel__indicator.is-active button) {
    background-color: $mainColor;
}

:deep(.el-carousel__indicators--horizontal) {
    margin-bottom: 10vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 70vw;
}

.textArea {
    position: absolute;
    z-index: 10;
    left: 15%;
    top: 28%;
    transition: opacity 0.2s ease;

    img {
        width: auto;
        height: 15rem;
    }

    .brief {
        width: 32vw;
        font-size: 1.3rem;
        // letter-spacing: 0.1rem;
        line-height: 2rem;
        color: #FFFFFF;
        margin-top: 3rem;
        font-family: "Montserrat", serif;
        font-weight: 450;
    }
}

@media (max-width: 768px) {
    .main {
        padding-top: 4rem;
    }

    .textArea {
        left: 5%;
        top: 20%;
        width: 90%;
        background-color: rgba(255, 255, 255, 0.55);
        backdrop-filter: blur(5px);
        padding: 1.5rem;
        border-radius: 1rem;
        box-sizing: border-box;
        
        img {
            height: 6rem; // Adjusted height
            width: auto;
            max-width: 100%;
        }

        .brief {
            width: 100%;
            font-size: 0.95rem;
            margin-top: 1rem;
            line-height: 1.6rem;
            font-weight: 600;
            color: #2C2B2B !important;
        }
    }
    
    :deep(.el-carousel__indicators--horizontal) {
        width: 90vw;
        margin-bottom: 5vh;
    }
    
    :deep(.el-carousel__button) {
        width: 28vw;
    }

    :deep(.el-carousel__arrow) {
        display: none;
    }
}

</style>